import { Headers } from '@angular/http';

// TODO: Make it generic<M> instead of json:any
export class ResponseWrapper {
    constructor(public headers: Headers,
                public json: any,
                public status: number) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/response-wrapper.model.ts